import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import CalendarIcon from '@mui/icons-material/CalendarTodayOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import { useTranslation } from 'react-i18next';

import { SidebarTypes } from 'layout/MainLayout/components/Sidebar/types';
import { HomeRoutePath } from 'shared/constants/router';
import { useIsAdminView, useUserRole } from 'shared/hooks/user';
import { UserRole } from 'shared/types';

import type { NavigationItem } from 'layout/MainLayout/components/Sidebar/types';

export const useDefaultNavigationItems = (): NavigationItem[] => {
  const { t } = useTranslation();
  const isAdminView = useIsAdminView();
  const role = useUserRole();

  return isAdminView || role === UserRole.Student || role === UserRole.Parent
    ? [
        {
          label: t('sidebar.dashboard'),
          icon: <DashboardOutlinedIcon />,
          to: HomeRoutePath.Dashboard,
          sidebarType: SidebarTypes.DEFAULT,
        },
        {
          label: t('sidebar.calendar'),
          icon: <CalendarIcon />,
          to: HomeRoutePath.Calendar,
          sidebarType: SidebarTypes.DEFAULT,
        },
        {
          label: t('sidebar.subjects'),
          icon: <SchoolOutlinedIcon />,
          to: HomeRoutePath.Subjects,
          sidebarType: SidebarTypes.DEFAULT,
        },

        // TODO: find a way to add "/overview" into progress path
        {
          label: t('sidebar.progress'),
          icon: <AutoGraphOutlinedIcon />,
          to: HomeRoutePath.Progress,
          sidebarType: SidebarTypes.DEFAULT,
        },
        {
          label: t('sidebar.schoolLinks'),
          icon: <FilePresentOutlinedIcon />,
          to: HomeRoutePath.SchoolLinks,
          sidebarType: SidebarTypes.DEFAULT,
        },
        {
          label: t('sidebar.library'),
          icon: <LibraryBooksOutlinedIcon />,
          to: HomeRoutePath.Library,
          sidebarType: SidebarTypes.DEFAULT,
        },
        {
          label: t('sidebar.reports'),
          icon: <DocumentScannerOutlinedIcon />,
          to: HomeRoutePath.Reports,
          sidebarType: SidebarTypes.DEFAULT,
        },
      ]
    : [];
};
